export enum TypeScreeningTabsEnum {
    SINTOMA = 1,
    DETALHE_SINTOMA = 2,
    LOCAL_EXAMES = 3,
    CONFIRMACAO_DADOS = 4
}